import cx from "classnames";
import { OverflowText, Table } from "@theorgchartdev/storybook";
import { ProfileTableValue } from "@/appComponents/Blocks/Cards/ProfileBaseballCard/ProfileTableValue";

const RecordFieldsTable = props => {
  const RecordFieldLabel = ({ rowState }) => {
    const { field, fieldDef } = rowState.data;
    const fieldId = fieldDef?.GetFieldID();
    return (
      <div style={{ width: "100%" }} key={fieldId}>
        <OverflowText
          size="xsmall"
          clamp={2}
          colorModifier={"grey"}
          dataTestId={`profile-field-row--${fieldId}`}
        >
          {field}
        </OverflowText>
      </div>
    );
  };

  const RecordValueLabel = ({ rowState }) => {
    const data = rowState?.data;
    const starredFields = props.starredFields ?? [];
    const enableStarring = props.enableStarring ?? false;
    const { fieldDef } = data;
    const isFavorite = enableStarring && starredFields.includes(fieldDef?.GetFieldName());
    return (
      <ProfileTableValue
        key={rowState?.data.field}
        onUpdateFavorite={fvPair => props.toggleFavoriteField?.(fvPair)}
        isFavorite={isFavorite}
        enableStarring={enableStarring}
        enableAdd={starredFields.length < 3}
        fVPair={data}
      />
    );
  };

  const columns = [
    {
      field: "field",
      type: "cellRenderer",
      columnWidth: "fifty",
      initSortDirection: "asc",
      CellRenderer: RecordFieldLabel
    },
    {
      field: "value",
      type: "cellRenderer",
      columnWidth: "fifty",
      CellRenderer: RecordValueLabel
    }
  ];

  return (
    <div className={cx(`${props.className}-table`)}>
      <Table
        sortEnabled={props.sortEnabled ?? true}
        columns={columns}
        rowSize="tinyR"
        textSize="smallT"
        tableLayout={"fixed"}
        showHeader={false}
        data={props.data}
      />
    </div>
  );
};

export default RecordFieldsTable;
